<template>
  <div>
    <b-card
      v-if="!settingsLoaded"
      class="d-flex"
    >
      <Loading />
    </b-card>

    <div v-else>
      <b-card
        v-for="(data, index) in settingsResult"
        :key="index"
      >
        <b-card-text class="text-center">
          <h2>
            {{ $t("SettingPageCard.title") }}
          </h2>
        </b-card-text>
        <div class="">
          <b-card-title>
            {{ $t("SettingPageCard.bookeepInvoice") }}
          </b-card-title>
          <b-card-text class="">
            <b-form-checkbox
              v-model="data.auto_bookkeep"
              class="custom-control-primary"
              @input="
                addConfigurationParams('auto_bookkeep', data.auto_bookkeep)
              "
            >
              {{ renderText("auto_bookkeep") }}
              <feather-icon
                v-b-tooltip.hover.v-primary
                size="16"
                :title="renderText('auto_bookkeep')"
                icon="HelpCircleIcon"
                class="mr-50"
              />
            </b-form-checkbox>

            <!-- BookkeeepList -->
            <Bookkeep
              :text-helper="helptext"
              :hide-when-empty="true"
              :enabled="data.auto_bookkeep"
              @bookeep="addNewBookList($event)"
            />
          </b-card-text>
        </div>

        <div>
          <b-card-title>
            {{ $t("SettingPageCard.sendInvoicesDirect") }}
          </b-card-title>
          <b-card-text>
            <b-form-checkbox
              v-model="data.auto_send_regular"
              class="custom-control-primary"
              @input="
                addConfigurationParams(
                  'auto_send_regular',
                  data.auto_send_regular
                )
              "
            >
              {{ renderText("auto_send_regular") }}
              <feather-icon
                v-b-tooltip.hover.v-primary
                size="16"
                :title="renderText('auto_send_regular')"
                icon="HelpCircleIcon"
                class="mr-50"
              />
            </b-form-checkbox>
          </b-card-text>

          <b-card-text>
            <b-form-checkbox
              v-model="data.use_print_service_for_print"
              class="custom-control-primary"
              @input="
                addConfigurationParams(
                  'use_print_service_for_print',
                  data.use_print_service_for_print
                )
              "
            >
              {{ renderText("use_print_service_for_print") }}
              <feather-icon
                v-b-tooltip.hover.v-primary
                size="16"
                :title="renderText('use_print_service_for_print')"
                icon="HelpCircleIcon"
                class="mr-50"
              />
            </b-form-checkbox>
          </b-card-text>

          <div class="mt-2">
            <b-row>
              <b-col
                xl="4"
                sm="6"
                class="py-1 position-relative"
              >
                <v-select
                  v-model="data.regularSendValue"
                  :clearable="false"
                  :options="sendMethods"
                  :placeholder="
                    $t('SettingPageCard.placeHolder.chooceSendMethod')
                  "
                  class="per-page-selector-send-method d-inline-block"
                  @input="
                    addConfigurationParams(
                      'regular_send_method',
                      data.regularSendValue
                    )
                  "
                />
                <feather-icon
                  v-b-tooltip.hover.v-primary
                  size="16"
                  :title="renderText('regular_send_method')"
                  icon="HelpCircleIcon"
                  class="ml-50 position-absolute"
                  style="top: 0px"
                />
              </b-col>
            </b-row>

            <RegularCriteria
              :text-helper="helptext"
              :hide-when-empty="true"
              :enabled="data.auto_send_regular"
              @regular="addRegularList($event)"
            />
          </div>
        </div>

        <div v-if="showNoxSettings">
          <b-card-title>
            {{ $t("SettingPageCard.sendInvoicesViaFortnox") }}
          </b-card-title>
          <b-card-text>
            <b-form-checkbox
              v-model="data.auto_send_nox"
              class="custom-control-primary"
              @input="
                addConfigurationParams('auto_send_nox', data.auto_send_nox)
              "
            >
              {{ renderText("auto_send_nox") }}
              <feather-icon
                v-b-tooltip.hover.v-primary
                size="16"
                :title="renderText('auto_send_nox')"
                icon="HelpCircleIcon"
                class="mr-50"
              />
            </b-form-checkbox>
          </b-card-text>

          <div class="mt-2">
            <b-row>
              <b-col
                xl="4"
                sm="6"
                class="d-flex py-1 position-relative"
              >
                <v-select
                  v-model="data.sendNoxValue"
                  :clearable="false"
                  :options="sendMethodsNox"
                  :placeholder="
                    $t('SettingPageCard.placeHolder.chooceSendMethod')
                  "
                  class="per-page-selector-send-method d-inline-block"
                  @input="
                    addConfigurationParams('nox_send_method', data.sendNoxValue)
                  "
                />
                <feather-icon
                  v-b-tooltip.hover.v-primary
                  size="16"
                  :title="renderText('nox_send_method')"
                  icon="HelpCircleIcon"
                  class="ml-50 position-absolute"
                  style="top: 0px; right: -8px"
                />
              </b-col>
            </b-row>

            <NoxSendCriteria
              :text-helper="helptext"
              :hide-when-empty="true"
              :enabled="data.auto_send_nox"
              @nox="addNoxList($event)"
            />
          </div>
        </div>

        <div class="">
          <b-card-title>
            {{ $t("SettingPageCard.backDaysTime") }}
          </b-card-title>
          <b-card-text class="">
            <div
              class="d-flex align-items-center"
              style="gap: 0.5rem"
            >
              <p class="mb-0">
                {{ renderText("days_back_in_time") }}
              </p>
              <feather-icon
                v-b-tooltip.hover.v-primary
                size="16"
                :title="renderText('days_back_in_time')"
                icon="HelpCircleIcon"
                class="mr-50"
              />
            </div>

            <div class="mt-2">
              <b-row class="">
                <b-col
                  xl="3"
                  sm="6"
                  class="py-1"
                >
                  <validation-observer ref="formDays">
                    <b-form-group>
                      <validation-provider
                        #default="{ errors }"
                        :name="
                          $t('SettingPageCard.placeHolder.chooseStartDays')
                        "
                        rules="integer|max7:7"
                      >
                        <b-form-input
                          v-model="data.days_back_in_time"
                          :placeholder="
                            $t('SettingPageCard.placeHolder.numberOfDays')
                          "
                          @input="
                            addConfigurationParams(
                              'days_back_in_time',
                              data.days_back_in_time
                            )
                          "
                        />
                        <small class="text-danger">
                          {{ errors[0] }}
                        </small>
                      </validation-provider>
                    </b-form-group>
                  </validation-observer>
                </b-col>
              </b-row>
            </div>
          </b-card-text>
        </div>

        <div class="">
          <b-card-title>
            {{ $t("SettingPageCard.starDate") }}
          </b-card-title>
          <b-card-text class="">
            <div
              class="d-flex align-items-center"
              style="gap: 0.5rem"
            >
              <p class="mb-0">
                {{ renderText("start_date") }}
              </p>
              <feather-icon
                v-b-tooltip.hover.v-primary
                size="16"
                :title="renderText('start_date')"
                icon="HelpCircleIcon"
                class="mr-50"
              />
            </div>

            <div class="">
              <b-row class="">
                <b-col
                  xl="3"
                  sm="6"
                  class="py-1"
                >
                  <date-picker
                    v-model="data.start_date"
                    value-type="format"
                    prefix-class="xmx"
                    @input="changeDate('start_date', data.start_date)"
                  />
                  <small
                    v-show="startDateMsg"
                    class="text-danger"
                  >
                    {{ $t("Message.messageStartDateError") }}
                  </small>
                </b-col>
              </b-row>
            </div>
          </b-card-text>
        </div>

        <div class="">
          <b-card-title>
            <span class="mr-1">
              {{ $t("SettingPageCard.upgradeOption") }}
            </span>
            <feather-icon
              v-b-tooltip.hover.v-primary
              size="16"
              :title="renderText('upgrade_option')"
              icon="HelpCircleIcon"
              class="mr-50"
            />
          </b-card-title>
          <b-card-text class="">
            <div class="">
              <div
                v-for="(upgradeOption, index) in upgradeOptions"
                :key="index"
                class="mb-1 d-flex align-content-center"
              >
                <b-form-radio
                  v-model="data.upgrade_option"
                  :value="upgradeOption.value"
                  @input="
                    addConfigurationParams(
                      'upgrade_option',
                      data.upgrade_option
                    )
                  "
                >
                  {{ renderText(upgradeOption.text) }}
                </b-form-radio>
                <div
                  class="my-auto"
                  style="margin-left: 5px"
                >
                  <feather-icon
                    v-b-tooltip.hover.v-primary
                    size="16"
                    icon="HelpCircleIcon"
                    :title="renderText(upgradeOption.text)"
                  />
                </div>
              </div>
            </div>
          </b-card-text>
        </div>

        <div class="">
          <b-card-title>
            <span class="mr-1">
              {{ $t("SettingPageCard.subscriber") }}
            </span>
            <feather-icon
              v-b-tooltip.hover.v-primary
              size="16"
              icon="HelpCircleIcon"
              class="mr-50"
              :title="renderText('subscription')"
            />
          </b-card-title>
          <b-card-text class="">
            <SubscriptionToggle />

            <div class="d-flex justify-content-center py-4">
              <div style="width: 300px">
                <b-button
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  variant="primary"
                  block
                  @click="updateConfiguration(data)"
                >
                  <span v-if="loading">
                    <b-spinner
                      small
                      type="grow"
                    />
                    {{ $t("Message.loading") }}...
                  </span>

                  <span v-else>
                    {{ $t("SettingPageCard.save") }}
                  </span>
                </b-button>
              </div>
            </div>
          </b-card-text>
        </div>
      </b-card>
    </div>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { integer, max7 } from '@validations'
import vSelect from 'vue-select'
import Ripple from 'vue-ripple-directive'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { settingsMixins } from '@/mixins/settingsMixins'
import PaymentToggler from '@/@core/components/subscription/PaymentToggler.vue'
import Bookkeep from '@/@core/components/settings/Bookkeep.vue'
import RegularCriteria from '@/@core/components/settings/RegularCriteria.vue'
import NoxSendCriteria from '@/@core/components/settings/NoxSendCriteria.vue'
import SubscriptionToggle from '@/@core/components/settings/SubscriptionToggle.vue'
import { BFormDatepicker } from 'bootstrap-vue'
import DatePicker from 'vue2-datepicker'

export default {
  directives: {
    Ripple,
  },
  components: {
    vSelect,
    PaymentToggler,
    Bookkeep,
    RegularCriteria,
    NoxSendCriteria,
    ValidationProvider,
    ValidationObserver,
    BFormDatepicker,
    SubscriptionToggle,
    DatePicker,
  },
  mixins: [settingsMixins],
  data() {
    return {
      upgradeOptions: [
        {
          text: 'upgrade_option_auto_upgrade',
          value: 'auto_upgrade',
        },
        {
          text: 'upgrade_option_pause_notify',
          value: 'pause_and_notify',
        },
      ],
      loading: false,
      max7,
      integer,
      configurationParams: {},
      btnDisabled: true,
      openField: false,
      bookeepList: '',
      regularList: '',
      noxList: '',
      currentAccountingProgram: null,
      startDateMsg: false,
    }
  },
  watch: {},

  computed: {
    showNoxSettings() {
      return this.currentAccountingProgram !== 'spiris'
    },
  },

  methods: {
    normalizeAccountingProgram(program) {
      const normalized = String(program || '').toLowerCase()
      if (normalized === 'fortnox' || normalized === 'spiris') {
        return normalized
      }
      return null
    },
    getProgramFromHealthPayload(payload) {
      const directProgram = this.normalizeAccountingProgram(
        payload && payload.accounting_program,
      )
      if (directProgram) return directProgram

      const subscriptions = Array.isArray(payload && payload.subscriptions)
        ? payload.subscriptions
        : []
      const activeSubscription = subscriptions.find(
        item => item && item.active && item.accounting_program,
      )
      if (activeSubscription) {
        return this.normalizeAccountingProgram(activeSubscription.accounting_program)
      }

      const firstWithProgram = subscriptions.find(
        item => item && item.accounting_program,
      )
      return this.normalizeAccountingProgram(
        firstWithProgram && firstWithProgram.accounting_program,
      )
    },
    async resolveAccountingProgram() {
      try {
        const healthRes = await this.$useJwt.subscriptionHealth()
        const healthPayload = (healthRes && healthRes.data && healthRes.data.data)
          || (healthRes && healthRes.data)
          || {}
        const healthProgram = this.getProgramFromHealthPayload(healthPayload)
        if (healthProgram) {
          this.currentAccountingProgram = healthProgram
          return
        }
      } catch (e) {}

      try {
        const subscriptionRes = await this.$useJwt.subscription()
        const payload = (subscriptionRes && subscriptionRes.data && subscriptionRes.data.data)
          || (subscriptionRes && subscriptionRes.data)
          || []
        const subscriptions = Array.isArray(payload) ? payload : []
        const activeSubscription = subscriptions.find(
          item => item && item.active && item.accounting_program,
        )
        const fallbackSubscription = activeSubscription
          || subscriptions.find(item => item && item.accounting_program)
        const program = this.normalizeAccountingProgram(
          fallbackSubscription && fallbackSubscription.accounting_program,
        )
        if (program) {
          this.currentAccountingProgram = program
        }
      } catch (e) {}
    },
    changeDate(params, value) {
      const defaultDate = new Date(this.copySettingsResult[0][params])
      const newDate = new Date(value)
      const days7Ago = new Date(defaultDate.getTime())
      days7Ago.setDate(days7Ago.getDate() - 7)

      if (days7Ago.getTime() > newDate.getTime()) {
        this.startDateMsg = true
      } else {
        this.startDateMsg = false
        this.configurationParams[params] = value
      }
    },
    addConfigurationParams(params, value) {
      if (this.copySettingsResult[0][params] !== value) {
        // Cheking value variable
        this.configurationParams[params] = value.value || value
      }
    },
    updateConfiguration(value) {
      this.loading = true

      const tasks = []

      if (this.bookeepList && this.bookeepList.length > 0) {
        tasks.push(this.updateBookList())
      }
      if (this.regularList && this.regularList.length > 0) {
        tasks.push(this.updateSendRegularList())
      }
      if (this.noxList && this.noxList.length > 0) {
        tasks.push(this.updateNoxCriteria())
      }
      if (Object.keys(this.configurationParams).length !== 0) {
        tasks.push(
          this.$useJwt
            .updateConfigure(value.uuid, this.configurationParams)
            .then(res => {
              const { data } = res
              this.popup(
                data[this.messageLang],
                'success',
                this.$t('Message.Success'),
                'CheckIcon',
              )
            })
            .catch(err => {
              if (err && err.response) {
                console.log(err.response.data.message)
                // Swallow to allow other tasks to complete
              }
            }),
        )
      }

      if (tasks.length === 0) {
        this.popup(
          this.$t('Message.warningMsg'),
          'warning',
          this.$t('Message.warning'),
          'AlertTriangleIcon',
        )
        this.loading = false
        return
      }

      Promise.all(tasks)
        .then(() => {
          this.getConfiguration()
        })
        .finally(() => {
          this.loading = false
          this.btnDisabled = true
        })
    },

    updateBookList() {
      const requests = this.bookeepList.map(element => {
        const req = element.uuid
          ? this.$useJwt.updateBookKeepList(element.uuid, element)
          : this.$useJwt.addBookKeepList(element)
        return req.then(res => {
          const { data } = res
          this.popup(
            data[this.messageLang],
            'success',
            this.$t('Message.Success'),
            'CheckIcon',
          )
        })
      })
      return Promise.all(requests).then(() => {
        this.bookeepList = []
      })
    },

    updateSendRegularList() {
      const requests = this.regularList.map(element => {
        const req = element.uuid
          ? this.$useJwt.updateRegularCriteriaList(element.uuid, element)
          : this.$useJwt.addRegularCriteriaList(element)
        return req.then(res => {
          const { data } = res
          this.popup(
            data[this.messageLang],
            'success',
            this.$t('Message.Success'),
            'CheckIcon',
          )
        })
      })
      return Promise.all(requests).then(() => {
        this.regularList = []
      })
    },

    updateNoxCriteria() {
      const requests = this.noxList.map(element => {
        const req = element.uuid
          ? this.$useJwt.updateNoxCriteriaList(element.uuid, element)
          : this.$useJwt.addNoxCriteriaList(element)
        return req.then(res => {
          const { data } = res
          this.popup(
            data[this.messageLang],
            'success',
            this.$t('Message.Success'),
            'CheckIcon',
          )
        })
      })
      return Promise.all(requests).then(() => {
        this.noxList = []
      })
    },

    addNewBookList(value) {
      this.bookeepList = value
    },

    addRegularList(value) {
      this.regularList = value
    },

    addNoxList(value) {
      this.noxList = value
    },

    popup(message, variant, title, icon) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title,
          icon,
          variant,
          text: message,
        },
      })
    },
  },
  mounted() {
    this.resolveAccountingProgram()
  },
}
</script>

<style scoped lang="scss">
.per-page-selector-send-method {
  width: 100%;
}

.invoice-filter-select {
  min-width: 190px;

  ::v-deep .vs__selected-options {
    flex-wrap: nowrap;
  }

  ::v-deep .vs__selected {
    width: 100px;
  }
}
</style>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
@import "@core/scss/vue/libs/datepicker.scss";
</style>
